<template>
  <div>
    <i :class="clz" :style="styl"></i>
  </div>

</template>

<script>
  export default {
    props: ['myClass', 'name', 'myStyle'],
    data(){
      return {
        styl: this.myStyle,
      }
    },
    computed: {
      clz: function () {
        return `iconfont ${this.name} ${this.myClass || ''}`
      }
    }
  }

</script>
